import { Collapse } from "@mui/material";
import { Fragment, useState } from "react";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { AiOutlinePlus } from "react-icons/ai";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { HiMinus } from "react-icons/hi";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdCloseFullscreen,
  MdExpand,
} from "react-icons/md";
import styles from "./filter_box_checkbox.module.scss";

// types (collapsible, normal)

export const FilterBoxCheckbox = ({
  data,
  title,
  selected,
  expanded,
  search = false,
  loading = false,
  type = "collapsible",
  ...props
}) => {
  const [cardOpen, setCardOpen] = useState(true);
  const handleCard = () => {
    setCardOpen(!cardOpen);
  };

  const onCheck = (checked) => {
    if (props.onChange) props.onChange(checked);
  };

  const onExpand = (expanded) => {
    if (props.getExpand) props.getExpand(expanded);
  };

  if (data && data.length > 0) {
    return (
      <Fragment>
        {type == "collapsible" && (
          <div className={styles.filter_option}>
            <div onClick={handleCard} className={styles.option_title_wrapper}>
              <span className={styles.option_title}>{title || ""}</span>
              <span className={styles.icon}>
                {cardOpen ? <FiChevronUp /> : <FiChevronDown />}
              </span>
            </div>

            <div className={styles.filter_checkbox_wrapper}>
              <Collapse in={cardOpen} timeout="auto" unmountOnExit>
                {/* {search && (
              <div className={styles.searach_wrapper}>
                <input type="text" placeholder="Search Here" />
                <FiSearch className={styles.searach_icon} />
              </div>
            )} */}

                <CheckboxTree
                  checked={selected}
                  expanded={expanded}
                  nodes={data}
                  className={"test"}
                  onCheck={onCheck}
                  onExpand={onExpand}
                  disabled={loading}
                  icons={{
                    check: <MdCheckBox />,
                    uncheck: <MdCheckBoxOutlineBlank />,
                    halfCheck: <MdCheckBox />,
                    expandClose: <AiOutlinePlus />,
                    expandOpen: <HiMinus />,
                    expandAll: <MdExpand />,
                    collapseAll: <MdCloseFullscreen />,
                    parentClose: false,
                    parentOpen: false,
                    leaf: false,
                  }}
                />
              </Collapse>
            </div>
          </div>
        )}
        {type == "normal" && (
          <div className={styles.filter_checkbox_wrapper}>
            <CheckboxTree
              checked={selected}
              expanded={expanded}
              nodes={data}
              className={"test"}
              onCheck={onCheck}
              onExpand={onExpand}
              disabled={loading}
              icons={{
                check: <MdCheckBox />,
                uncheck: <MdCheckBoxOutlineBlank />,
                halfCheck: <MdCheckBox />,
                expandClose: <AiOutlinePlus />,
                expandOpen: <HiMinus />,
                expandAll: <MdExpand />,
                collapseAll: <MdCloseFullscreen />,
                parentClose: false,
                parentOpen: false,
                leaf: false,
              }}
            />
          </div>
        )}
      </Fragment>
    );
  }
};

export default FilterBoxCheckbox;
